<div style="background-color: #2ca8ff; width: 130%; height: 50px;margin-bottom: 5px" *ngIf="!hideLogin">
  <p style="text-align: center; color: white; line-height: 50px;">Now you can log in using your LinkedIn account.</p>
</div>
<div class="card card-login" style="width: 130%" *ngIf="!hideLogin">
  <div class="card-content">

    <!--logo section -->
    <div class="row">
      <div class="container-fluid">
        <div class="login-header text-center" style="width: 50%; margin-left: 28%">
          <img [src]="this.logoPath" class="logo" alt="able+" title="able+" />
          <h3 class="title hidden">able+</h3>
        </div>
      </div>
    </div>
    <!--logo section end-->

    <!--First step-->
    <div class="col" >
      <div class="input-group col-md-8 col-lg-8 col-sm-8 col-xs-8" style="margin-left: 18%">
        <div class="col" >
          <button (click)="onLoginWithLinkedInClick()" class="fb btn" style="text-align: left; background-color: rgb(40,103,178); color: white; display: block; margin-bottom: 30px; width: 100%">
            <i class="fa fa-linkedin fa-fw" style="float:right"></i>Log in with LinkedIn
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card card-login" style="width: 130%" *ngIf="linkCheckErrorMessage">
  <div class="card-content">

    <!--logo section -->
    <div class="row">
      <div class="container-fluid">
        <div class="login-header text-center" style="width: 50%; margin-left: 28%">
          <img [src]="this.logoPath" class="logo" alt="able+" title="able+" />
          <h3 class="title hidden">able+</h3>
        </div>
      </div>
    </div>
    <!--logo section end-->

    <!--First step-->
    <div class="col" >
      <div class="input-group col-md-8 col-lg-8 col-sm-8 col-xs-8" style="margin-left: 18%">
        <h5 style="text-align: center; margin-bottom: 30px; margin-top: 30px">{{linkCheckErrorMessage}}</h5>
      </div>
    </div>
  </div>
</div>
